
import * as React from 'react';
//import "../Users&Roles/UsersTab.css";
import { styled } from '@mui/system';
import TabsUnstyled from '@mui/base/TabsUnstyled';
import TabsListUnstyled from '@mui/base/TabsListUnstyled';
import TabPanelUnstyled from '@mui/base/TabPanelUnstyled';
import { buttonUnstyledClasses } from '@mui/base/ButtonUnstyled';
import TabUnstyled, { tabUnstyledClasses } from '@mui/base/TabUnstyled';
import BiddingInterests from './BiddingInterests';
import ProficiencyAndCapabilities from './ProficiencyAndCapabilities';
import { useLocation } from 'react-router-dom';
import { useGlobalComponent } from '../../../pages/commom/GlobalComponentProvider';
import { useEffect, useState } from 'react';
import { HasScreenPermissions } from '../../../utils/Token';
// import INFO from "../../utils/Enums.json";
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import ClaycoBiddingInterest from './ClaycoBiddingInterest';


const white = {
  50: '#fff',
  100: '#fff',
  200: '#fff',
  300: '#fff',
  400: '#fff',
  500: '#F2F4F7',
  600: '#030202',
  700: '#0059B2',
  800: '#fff',
  900: '#fff',
};

const Tab = styled(TabUnstyled)`
  font-family: IBM Plex Sans, sans-serif;
  color: black;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: bold;
  background-color: transparent;
  width: 100%;
  padding: 10px 5px;
  margin: 6px 6px;
  border: none;
  border-radius: 5px;
  display: flex;
  justify-content: center;

  &:hover {
    background-color: ${white[400]};
  }

  &:focus {
    color: #fff;
    border-radius: 3px;
    outline: 2px solid ${white[200]};
    outline-offset: 2px;
  }

  &.${tabUnstyledClasses.selected} {
    background-color: ${white[50]};
    color: ${white[600]};
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const TabPanel = styled(TabPanelUnstyled)`
  width: 100%;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
`;

const TabsList = styled(TabsListUnstyled)`
  min-width: 400px;
  background-color: ${white[500]};
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
`;


export default function FeaturesTab({ MOveValue }) {
  // const defval = val == 4 ? 1 : 0

  const { currentActiveTab, currentActiveSubTab } = useGlobalComponent();

  const [value, setValue] = useState(0);
  const [DisValue, setDisValue] = useState("");
  const location = useLocation();

  const findFirstAccessibleTab = () => {
    // if (!HasScreenPermissions(INFO?.BiddingInterestsList?.actionName)) return 0;
    // if (!HasScreenPermissions(INFO?.ProficiencyCapabilitiesList?.actionName)) return 1;
    // if (!HasScreenPermissions(INFO?.ClaycoBiddingInterestsList?.actionName)) return 2;
    if (location?.pathname.slice(1) == INFO?.BiddingInterestsList?.actionName) {
      return 0;
    } else if (location?.pathname.slice(1) == INFO?.ProficiencyCapabilitiesList?.actionName) {
      return 1;
    } else if (location?.pathname.slice(1) == INFO?.ClaycoBiddingInterestsList?.actionName) {
      return 2;
    }else {
      return 0;
    }

  };

  useEffect(() => {
    setValue(currentActiveSubTab);
    //setValue(currentActiveSubTab);
  }, [currentActiveSubTab, location]);

  useEffect(() => {
    const firstAccessibleTab = findFirstAccessibleTab();
    setValue(firstAccessibleTab);
  }, [INFO, location]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>

      <div className="row" >
        <TabsUnstyled value={value} onChange={handleChange} sx={{ backgroundColor: "#fff" }}>
          <TabsList sx={{ width: "700px" }} >
            <Tab hidden={HasScreenPermissions(INFO?.BiddingInterestsList?.actionName)}>Bidding Interests</Tab>
            <Tab hidden={HasScreenPermissions(INFO?.ProficiencyCapabilitiesList?.actionName)}>Proficiency & Capabilities</Tab>
            <Tab hidden={HasScreenPermissions(INFO?.ClaycoBiddingInterestsList?.actionName)}>ClaycoBidding Interests</Tab>
          </TabsList>
          <TabPanel value={0} hidden={HasScreenPermissions(INFO?.BiddingInterestsList?.actionName)}><BiddingInterests /></TabPanel>
          <TabPanel value={1} hidden={HasScreenPermissions(INFO?.ProficiencyCapabilitiesList?.actionName)}><ProficiencyAndCapabilities /> </TabPanel>
          <TabPanel value={2} hidden={HasScreenPermissions(INFO?.ClaycoBiddingInterestsList?.actionName)}><ClaycoBiddingInterest /> </TabPanel>
        </TabsUnstyled>
      </div>

    </>
  );
}
